import { useEffect } from "react"
import { useGetAdminGradesByQuestionMutation } from "./chartsApiSlice"
import BarChartComponentForQuestions from "./BarChartComponentForQuestions"
const QuestionCharts = ({questions, showNames}) => {
   const [getGrades, {
          data,
          isLoading,
          isSuccess,
          isError,
          error
      }] = useGetAdminGradesByQuestionMutation()
 useEffect(() => {
  if(questions.length > 0){
    getGrades({finalQuestionSet:questions})
  }
   
 }, [questions])
  if (isLoading) return <div>Loading...</div>
  if (isError) return <div>Error: {error}</div>

  return (
    <div>
      {data && data.map((question, index) => (<div key={index}>
          <BarChartComponentForQuestions data={question} showNames={showNames} />

          
          </div>
          ))}
    </div>
  )
}

export default QuestionCharts